// @flow
import React from 'react';
import {useHistory} from 'react-router-dom';
import {Divider, Grid, Typography, makeStyles} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {Add} from '@material-ui/icons';
import {useTypedSelector} from '../../../../store';
import VariantItem from '../VariantItem/VariantItem';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(1, 0),
    width: '100%',
    backgroundColor: '#ffffff',
    padding: theme.spacing(2),
    borderRadius: 12,
  },
  title: {
    color: colors.grey900,
    fontWeight: 600,
  },
  btn: {
    marginTop: theme.spacing(1),
    borderRadius: 8,
    width: '100%',
    border: '1px dashed #7B39FF',
    paddingTop: theme.spacing(2.25),
    paddingBottom: theme.spacing(2.25),
  },
  divider: {
    margin: theme.spacing(1, 0),
    background: colors.grey200,
  },
  list: {
    margin: theme.spacing(1, 0),
  },
}));
function VariantsList() {
  const classes = useStyles();
  const history = useHistory();
  const variants = useTypedSelector(
    state => state.products.globalProductVariantOptions
  );

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>
        Variantes creadas: {variants?.length ?? 0}
      </Typography>

      <Divider className={classes.divider} />

      <CustomButton
        className={classes.btn}
        onClick={() => history.push('/products-variants/new')}
      >
        <Add />
        Crear nueva variante
      </CustomButton>

      <div className={classes.list}>
        <Grid container spacing={1}>
          {variants?.map(v => (
            <Grid item xs={12} key={v.id}>
              <VariantItem variantOption={v} />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}

export default VariantsList;
